const initialState = {
  routes: [],
  navigation: [],
  userName: "",
  userEmail: "",
  userID: 0,
  userRole: "",
  userToken: "",
};

const userReducer = (state = initialState, action) => {
  if (action.type === "USER_LOGIN") {
    return action.userConfig;
  }

  if (action.type === "USER_LOGOUT") {
    return initialState;
  }
  
  return state;
};

export default userReducer;
